const getActions = () => [
  {
    route: '/products/',
    action: 'view',
    type: 'link',
    label: 'product.grid.cell.action.btn.view.label'
  }
];

export const getCommercialItem = commercialProduct => ({
  id: commercialProduct.id,
  code: commercialProduct.code,
  end_date: commercialProduct.end_date,
  product: commercialProduct?.technical_product?.id,
  rec_name: commercialProduct.name,
  start_date: commercialProduct.start_date,
  actions: getActions()
});

export const getCommercialProductList = commercialProducts => {
  try {
    return commercialProducts.map(commercialProduct => getCommercialItem(commercialProduct));
  } catch (e) {
    console.error(e)
    return [];
  }
};
